<div class="schedule-card">
  <div class="title">
    <fa-icon [icon]="['fas', 'calendar']"></fa-icon>
    {{ schedule?.title }}
  </div>

  <div class="info">
    <ng-container *ngFor="let item of exportScheduleProperties">
      <div class="info-row">
        <div class="text">
          <div class="icon"><fa-icon [icon]="item.icon"></fa-icon></div>
          {{ item.label | translate }}
        </div>
        <div class="value">{{ item.value }}</div>
      </div>
    </ng-container>

    <div class="tools">
      <div
        class="status"
        [ngClass]="{
          paused: schedule?.status?.id == 0,
          running: schedule?.status?.id == 1,
        }"
        (click)="toggleScheduleStatus(schedule.id)"
      >
        <span>{{ schedule.status?.title }}</span>
        <fa-icon
          [icon]="schedule.status?.id == 1 ? ['fas', 'pause'] : ['fas', 'play']"
        ></fa-icon>
      </div>
      <sui-button
        class="edit-btn"
        size="sm"
        variant="primary"
        [leadingIcon]="['fas', 'edit']"
        [iconOnly]="true"
        ariaLabel="Edit"
        (click)="edit(schedule)"
      ></sui-button>

      <sui-button
        class="delete-btn"
        size="sm"
        variant="danger"
        [leadingIcon]="['fas', 'trash']"
        [iconOnly]="true"
        ariaLabel="Delete"
        (click)="delete(schedule)"
      ></sui-button>
    </div>
  </div>
</div>
